import * as React from 'react'
import { Clouds } from '../../icons'
import { Styled } from './styled'

export const ThemeSwitcher = (props) => {
  const { checked, onChange, size = 's' } = props;
  return (
    <Styled.ThemeSwitcherContainer
      onClick={onChange && onChange}
      checked={checked}
      size={size}
    >
      <Styled.ThemeRound checked={checked} size={size} />
      <span><Clouds /></span>
    </Styled.ThemeSwitcherContainer>
  )
}
